import MuiStack from "@mui/material/Stack";
const Stack = MuiStack;
export default Stack;
